import React from 'react';
import { useDispatch } from 'react-redux';
import * as actions from "../../redux/actions";
import LaunchButton from './LaunchButton';
import tipsIcon from '../../assets/icons/tipsIcon.png';
import doubleTap from '../../assets/icons/doubleTap.png';
import adjustIcon from '../../assets/icons/adjust.png';
import rotateIcon from '../../assets/icons/rotate.png';

const DisplayPrompt = () => {
  const dispatch = useDispatch();

  const onClose = e => {
    dispatch(actions.setPromptView(false));
  };

  return (
    <div className="DisplayPrompt">
      <div className="DisplayPrompt-Content">
        <section className="Close-Modal" >
          <button onClick={onClose}>X</button>
        </section>
        <hr />
        <section className="Modal-Header">
          <h2>Helpful AR Viewing Hints</h2>
        </section>
        <hr />
        <section className="Prompt-Body">
          <div className="Prompt-Tips">
            <section className="Prompt-Row">
              <section className="Prompt-Icon">
                <img src={tipsIcon} alt="Double Tap Device" />
              </section>
              <section className="Prompt-Copy">
                <h5>Placing Image</h5>
                <p>Point your phone at a flat surface in a well lit room or space. Move your phone slowly, if the model does not appear.</p>
              </section>
            </section>
            <section className="Prompt-Row">
              <section className="Prompt-Icon">
                <img src={rotateIcon} alt="Double Tap Device" />
              </section>
              <section className="Prompt-Copy">
                <h5>Rotate Image</h5>
                <p>Move your finger across the screen to rotate AR image</p>
              </section>
            </section>
            <section className="Prompt-Row">
              <section className="Prompt-Icon">
                <img src={adjustIcon} alt="Adjust Scale" />
              </section>
              <section className="Prompt-Copy">
                <h5>Adjust Scale</h5>
                <p>Place two fingers on the screen and move them towards or away from each other to zoom</p>
              </section>
            </section>
            <section className="Prompt-Row">
              <section className="Prompt-Icon">
                <img src={doubleTap} alt="Double Tap Device" />
              </section>
              <section className="Prompt-Copy">
                <h5>Reset</h5>
                <p>Touching the screen two times will reset the location of the AR image</p>
              </section>
            </section>
          </div>
        </section>
        <hr />
        <section className="DisplayPrompt-Footer">
          <LaunchButton />
          <button onClick={onClose}>View in 3d</button>
        </section>
      </div>
    </div>
  );
};

export default DisplayPrompt;
